import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import icons from '../../../helpers/Icons';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const possibleLimitSelections = [10, 20, 50];

const PaginationComponent = ({
  handleLimitSelect,
  totalCount,
  currentMin,
  currentMax,
  rowsPerPage,
  onNextClick,
  onPrevClick,
  isLastPage,
  isFirstPage,
  t,
}) => {
  const renderedOptions = possibleLimitSelections.map((option) => (
    <option key={option}>{option}</option>
  ));

  const leftArrowClassNames = classNames('pagination__left', { disabled: isFirstPage, });
  const rightArrowClassNames = classNames('pagination__right', { disabled: isLastPage, });

  return (
    <div className="row">
      <div className="col-md-12 table__pagination">
        {`${t('rows_per_page')}:`}
        <select value={rowsPerPage} onChange={handleLimitSelect}>
          {renderedOptions}
        </select>
        <span className="table__pagination-numbers">
          {`${currentMin}-${currentMax} of ${totalCount}`}
        </span>
        <span>
          <span className={leftArrowClassNames} onClick={onPrevClick}>
            {icons('arrow_left')}
          </span>
          <span className={rightArrowClassNames} onClick={onNextClick}>
            {icons('arrow_right')}
          </span>
        </span>
      </div>
      <style jsx="true">{`
        .table__pagination {
          padding: 20px 15px;
          text-align: right;
        }
        .table__pagination select {
          max-width: 60px;
          margin: 0 12px;
          padding-top: 0;
          padding-bottom: 0;
        }
        .table__pagination-numbers {
          display: inline-block;
          margin-right: 18px;
        }
        .pagination__left, .pagination__right {
          vertical-align: middle;
          cursor: pointer;
          position: relative;
          top: 3px;
          font-size: 21px;
          font-weight: 700;
        }
        .pagination__left {
          margin-right: 18px;
        }
      `}</style>
    </div>
  );
};

PaginationComponent.propTypes = {
  t: PropTypes.func.isRequired,
  handleLimitSelect: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  currentMin: PropTypes.number.isRequired,
  currentMax: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  isLastPage: PropTypes.bool.isRequired,
  isFirstPage: PropTypes.bool.isRequired,
};

export default withScopedTranslations('pagination')(PaginationComponent);
